export default __webpack_public_path__ + "static/media/lfp01.f8cb2595.jpg";